/* tslint:disable */
import {
  Chip,
  UserAccount
} from '../index';

declare var Object: any;
export interface ChipProgressInterface {
  "userAccountId": number;
  "chipId": number;
  "data"?: string;
  "sessionUuid"?: string;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "completed"?: boolean;
  "duration"?: number;
  "moddingData"?: any;
  "totalTime"?: number;
  "id"?: number;
  chip?: Chip;
  user?: UserAccount;
}

export class ChipProgress implements ChipProgressInterface {
  "userAccountId": number;
  "chipId": number;
  "data": string;
  "sessionUuid": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "completed": boolean;
  "duration": number;
  "moddingData": any;
  "totalTime": number;
  "id": number;
  chip: Chip;
  user: UserAccount;
  constructor(data?: ChipProgressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChipProgress`.
   */
  public static getModelName() {
    return "ChipProgress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChipProgress for dynamic purposes.
  **/
  public static factory(data: ChipProgressInterface): ChipProgress{
    return new ChipProgress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChipProgress',
      plural: 'ChipProgresses',
      path: 'ChipProgresses',
      idName: 'id',
      properties: {
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "chipId": {
          name: 'chipId',
          type: 'number'
        },
        "data": {
          name: 'data',
          type: 'string'
        },
        "sessionUuid": {
          name: 'sessionUuid',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "completed": {
          name: 'completed',
          type: 'boolean',
          default: false
        },
        "duration": {
          name: 'duration',
          type: 'number'
        },
        "moddingData": {
          name: 'moddingData',
          type: 'any'
        },
        "totalTime": {
          name: 'totalTime',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        chip: {
          name: 'chip',
          type: 'Chip',
          model: 'Chip',
          relationType: 'belongsTo',
                  keyFrom: 'chipId',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'userAccountId',
          keyTo: 'id'
        },
      }
    }
  }
}
